import { createSignal } from 'solid-js';

const STORAGE_KEY = 'uchat-sidebar-collapsed';

const initialCollapsed = (): boolean => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
};

const [sidebarCollapsed, setSidebarCollapsed] = createSignal<boolean>(initialCollapsed());

const [mobileDrawerOpen, setMobileDrawerOpen] = createSignal<boolean>(false);

export const useUiStore = () => {
  const toggleSidebar = () => {
    setSidebarCollapsed((c) => {
      const next = !c;
      if (typeof window !== 'undefined') {
        localStorage.setItem(STORAGE_KEY, next ? '1' : '0');
      }
      return next;
    });
  };

  const openMobileDrawer = () => setMobileDrawerOpen(true);
  const closeMobileDrawer = () => setMobileDrawerOpen(false);

  return {
    sidebarCollapsed,
    toggleSidebar,
    mobileDrawerOpen,
    openMobileDrawer,
    closeMobileDrawer,
  };
};
